var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-muted mb-0"},[(_vm.user.isOnline)?_c('span',{staticClass:"text-info"},[_vm._v("\n    Online\n  ")]):_c('span',[_vm._v(_vm._s('Last seen ' + _vm.wasOnline))])])
}
var staticRenderFns = []

export { render, staticRenderFns }